// extracted by mini-css-extract-plugin
module.exports = {"email":"layout-module--email--2g86Q","privacypolicy":"layout-module--privacypolicy--TbvYy","list":"layout-module--list--1yLp4"};